import React, { useEffect, useState } from "react";
import queryString from 'query-string'
import { useTranslation } from 'react-i18next';

// core components
import { Col, Container, Row } from "stories/layout"
import { useNotification } from "stories/components/Notification"
import { useAuthContext } from "contexts/AuthContext";

// Import the new form component
import ActivationForm from "components/Forms/ActivationForm/ActivationForm";

const ActivationView = ({location, match, history, emailProps, setActiveStep}) => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const { setLanguage } = useAuthContext();
  
  let preSetValues = { }
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    const parsed = queryString.parse(location?.search);
    if (parsed?.token) {
      localStorage.removeItem("refreshToken");
      localStorage.setItem("accessToken", parsed?.token);
    }
  },[location])
  
  const historyState = history?.location?.state;
  const parsed = queryString.parse(location?.search);

  // Clean up URL parameters
  for (const [key, value] of Object.entries(parsed)) {
    if (key.startsWith("amp;")) {
      const newKey = key.replace("amp;", "");
      parsed[newKey] = value;
      delete parsed[key];
    }
  }

  let email = "";
  let pin_code = "";

  if (parsed?.email) {
    email = parsed.email;
  }
  else if (historyState?.email) {
    email = historyState.email;
  }
  else if (emailProps) {
    email = emailProps;
  }
  
  if (historyState?.pin_code) {
    pin_code = historyState.pin_code;
  }
  else if (parsed?.pin_code) {
    pin_code = parsed.pin_code;
  }

  preSetValues = {
    ...defaultValues,
    email: email,
    pin_code: pin_code,
  };

  if (loading) {
    return (
      <Container fluid></Container>
    )
  }
  
  return (
    <>
      {emailProps ? (
        <ActivationForm 
          history={history} 
          t={t} 
          notify={notify} 
          preSetValues={preSetValues} 
          emailProps={emailProps} 
          setActiveStep={setActiveStep} 
        />
      ) : (
        <Container className="mt-4 pb-5">
          <Row className="justify-content-center">
            <Col lg="6" md="7" className="">
              <ActivationForm 
                history={history} 
                t={t} 
                notify={notify} 
                preSetValues={preSetValues} 
                emailProps={emailProps} 
                setActiveStep={setActiveStep} 
              />
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}

const defaultValues = {
  id: null,
}

export default ActivationView;
